import { createDeprecatedBaseButtonDriver } from '../deprecated-base-button/base-button.driver';
export var createDeprecatedButtonDriver = function (wrapper) {
    return createDeprecatedBaseButtonDriver(wrapper, 'default');
};
export var createDeprecatedHollowButtonDriver = function (wrapper) {
    return createDeprecatedBaseButtonDriver(wrapper, 'default', true);
};
export var createDeprecatedPositiveButtonDriver = function (wrapper) {
    return createDeprecatedBaseButtonDriver(wrapper, 'positive');
};
export var createDeprecatedHollowPositiveButtonDriver = function (wrapper) {
    return createDeprecatedBaseButtonDriver(wrapper, 'positive', true);
};
export var createDeprecatedAttentionButtonDriver = function (wrapper) {
    return createDeprecatedBaseButtonDriver(wrapper, 'attention');
};
export var createDeprecatedHollowAttentionButtonDriver = function (wrapper) {
    return createDeprecatedBaseButtonDriver(wrapper, 'attention', true);
};
export var createDeprecatedDangerButtonDriver = function (wrapper) {
    return createDeprecatedBaseButtonDriver(wrapper, 'danger');
};
export var createDeprecatedHollowDangerButtonDriver = function (wrapper) {
    return createDeprecatedBaseButtonDriver(wrapper, 'danger', true);
};
export var createrDeprecatedPemiumButtonDriver = function (wrapper) {
    return createDeprecatedBaseButtonDriver(wrapper, 'premium');
};
export var createrDeprecatedHollowPemiumButtonDriver = function (wrapper) {
    return createDeprecatedBaseButtonDriver(wrapper, 'premium', true);
};
//# sourceMappingURL=button.driver.js.map